import React from 'react'

const HerderEnIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    fill='none'
    version='1.1'
    width='16'
    height='16'
    viewBox='0 0 16 16'
  >
    <defs>
      <clipPath id='master_svg0_70_5644'>
        <rect x='0' y='0' width='16' height='16' rx='0' />
      </clipPath>
    </defs>
    <g clipPath='url(#master_svg0_70_5644)'>
      <g>
        <path
          d='M3.1321849999999998,5.7455925Q0.928125,6.6272175,0.928125,8.0026075Q0.928125,9.3779875,3.1321849999999998,10.259617500000001Q5.156335,11.069267499999999,7.994795,11.069267499999999Q10.833255,11.0692775,12.857425,10.259617500000001Q15.061425,9.3779875,15.061425,8.0026075Q15.061425,6.6272175,12.857425,5.7455925Q10.833245,4.9359375,7.994795,4.9359375Q5.156335,4.9359375,3.1321849999999998,5.7455925ZM3.429305,9.516837500000001Q1.728125,8.8363675,1.728125,8.0026075Q1.728125,7.1688475,3.429305,6.4883775Q5.310395,5.7359375,7.994795,5.7359375Q10.679185,5.7359375,12.560325,6.4883775Q14.261425,7.1688475,14.261425,8.0026075Q14.261425,8.8363675,12.560325,9.516837500000001Q10.679185,10.2692675,7.994795,10.2692675Q5.310395,10.2692675,3.429305,9.516837500000001Z'
          fillRule='evenodd'
          fill='#333333'
          fillOpacity='1'
          style={{ mixBlendMode: 'passthrough' }}
        />
      </g>
      <g>
        <path
          d='M10.251805000000001,3.1399974999999998Q9.370175,0.9359375,7.994795,0.9359375Q6.619405,0.9359375,5.73778,3.1399974999999998Q4.928125,5.1641475,4.928125,8.0026075Q4.928125,10.8410575,5.73778,12.8652375Q6.619405,15.0692375,7.994795,15.0692375Q9.370175,15.0692375,10.251805000000001,12.8652375Q11.061465,10.8410675,11.061454999999999,8.0026075Q11.061454999999999,5.1641475,10.251805000000001,3.1399974999999998ZM6.480565,3.4371175Q7.161035,1.7359375,7.994795,1.7359375Q8.828555,1.7359375,9.509025000000001,3.4371175Q10.261455,5.3182075,10.261455,8.0026075Q10.261455,10.6869975,9.509025000000001,12.5681375Q8.828555,14.2692375,7.994795,14.2692375Q7.161035,14.2692375,6.480565,12.5681375Q5.728125,10.6869975,5.728125,8.0026075Q5.728125,5.3182075,6.480565,3.4371175Z'
          fillRule='evenodd'
          fill='#333333'
          fillOpacity='1'
          style={{ mixBlendMode: 'passthrough' }}
        />
      </g>
      <g>
        <ellipse
          cx='7.994791507720947'
          cy='8.002604007720947'
          rx='6.666666507720947'
          ry='6.666666507720947'
          fillOpacity='0'
          strokeOpacity='1'
          stroke='#333333'
          fill='none'
          strokeWidth='0.800000011920929'
          strokeLinejoin='round'
          style={{ mixBlendMode: 'passthrough' }}
        />
      </g>
    </g>
  </svg>
)

export default HerderEnIcon
